import * as styles from "./AutocompleteContent.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Autocomplete as BaseAutocomplete } from "@base-ui/react/autocomplete";
import { popupWidthStyle } from "@frontend/utils/popupWidth";

import type { AutocompleteContentProps } from "./Autocomplete.types";
import { AutocompletePortal } from "./AutocompletePortal";

export function AutocompleteContent({
  className,
  children,
  popupWidth,
  style,
  side = "bottom",
  align = "start",
  sideOffset = 4,
  alignOffset,
  anchor,
  ...props
}: AutocompleteContentProps): JSX.Element {
  return (
    <AutocompletePortal>
      <BaseAutocomplete.Positioner
        data-slot="autocomplete-positioner"
        className={styles.positioner}
        side={side}
        align={align}
        sideOffset={sideOffset}
        alignOffset={alignOffset}
        anchor={anchor}
      >
        <BaseAutocomplete.Popup
          data-slot="autocomplete-content"
          className={clsx(styles.popup, className)}
          style={(state) => ({
            ...popupWidthStyle(popupWidth),
            ...(typeof style === "function" ? style(state) : style),
          })}
          {...props}
        >
          {children}
        </BaseAutocomplete.Popup>
      </BaseAutocomplete.Positioner>
    </AutocompletePortal>
  );
}
